import { PayloadAction } from '@reduxjs/toolkit';
import { alarmApi } from 'api/alarmApi';
import { ListParams } from 'models';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { alarmActions } from './alarmSlice';

function* fetchPropertiesAlarmSaga(action: PayloadAction<ListParams>) {
  const callList = action.payload.array.map((x: string) => 
    call(alarmApi.fetchPropertiesAlarm, {
      id: x,
      type: action.payload.type,
    })
  );
  yield all(callList);
  yield put(alarmActions.fetchPropertiesAlarmSuccess());
}

export default function* alarmSaga() {
  yield takeLatest(alarmActions.fetchPropertiesAlarm.type, fetchPropertiesAlarmSaga);
}
